var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback, useContext, useEffect, useMemo, useRef } from 'react';
import { Method, TaskStatus, TaskType } from '@/modules/tasks/taskboard/kanban/constants';
import { useIntl } from 'react-intl';
import { getRelationName } from '@/shared/components/RelationName';
import SignalRService from '../services/SignalRService';
import { useDataContext } from './DataProvider';
import { getHoursMinutesFromTime, getTime } from '../utils/dateHelper';
import TimerRegistrationService from '../services/TimerRegistrationService';
import { useGetRunningTaskId } from '../hooks/task/useGetTimerRegistration';
import { formatListValue } from '../components/FormattedListValue';
import ToastrService from '../services/ToastrService';
import messages from '../messages/appMessages';
import { ModalType, useModalContext } from './ModalProvider';
import HandleHttpError from '../services/HandleHttpError';
export var TaskTimerContext = React.createContext(null);
export var useTaskTimerContext = function () {
    var ctx = useContext(TaskTimerContext);
    if (!ctx) {
        throw new Error('Wrap app with TaskTimerProvider');
    }
    return ctx;
};
var TaskTimerProvider = function (_a) {
    var children = _a.children;
    var intl = useIntl();
    var setShowModalInfo = useModalContext().setShowModalInfo;
    var defaultCompany = useDataContext().defaultCompany;
    var isTimerRunningForSubTaskId = useGetRunningTaskId();
    // const { updateTaskStatus } = useUpdateTaskStatus();
    var tasks = useRef([]);
    var processTimeRegistrationResult = useCallback(function (timeRegistrationResult, isAffectedRegistration) {
        if (isAffectedRegistration === void 0) { isAffectedRegistration = false; }
        return __awaiter(void 0, void 0, void 0, function () {
            var registration, taskName, duration;
            var _a;
            return __generator(this, function (_b) {
                if (!timeRegistrationResult)
                    return [2 /*return*/];
                registration = timeRegistrationResult.registration;
                taskName = null;
                if (registration === null || registration === void 0 ? void 0 : registration.plannedTaskId) {
                    taskName =
                        (_a = registration.plannedTaskName) !== null && _a !== void 0 ? _a : formatListValue({
                            list: 'tasktemplate',
                            id: registration.plannedTaskTemplateId,
                            intl: intl,
                            fallback: registration.plannedTaskName,
                        });
                }
                if (timeRegistrationResult.isRunning) {
                    ToastrService.success(taskName
                        ? intl.formatMessage(messages.msgTaskTimeRegistrationStarted, { task: taskName })
                        : intl.formatMessage(messages.msgTimerRegistrationStarted));
                }
                else if (timeRegistrationResult.discarded) {
                    ToastrService.info(intl.formatMessage(messages.msgTaskTimeRegistrationDiscarded));
                }
                else {
                    duration = getHoursMinutesFromTime(registration.durationMinutes);
                    ToastrService.success(intl.formatMessage(messages.msgTaskTimeRegistrationCreated, {
                        duration: duration,
                        relation: getRelationName(intl, registration.relation),
                    }), undefined, function () {
                        var task = {
                            relation: registration === null || registration === void 0 ? void 0 : registration.relation,
                            mainTaskId: registration === null || registration === void 0 ? void 0 : registration.mainPlannedTaskId,
                            mainTemplateId: registration === null || registration === void 0 ? void 0 : registration.mainTaskTemplateId,
                        };
                        setShowModalInfo({
                            modalType: ModalType.TimeRegistration,
                            task: task,
                            registration: registration,
                        });
                    });
                }
                if (timeRegistrationResult.affectedRegistrations &&
                    timeRegistrationResult.affectedRegistrations.length > 0) {
                    timeRegistrationResult.affectedRegistrations.forEach(function (affectedRegistration) {
                        processTimeRegistrationResult(affectedRegistration, true);
                    });
                }
                return [2 /*return*/];
            });
        });
    }, [intl, setShowModalInfo]);
    var taskTimeRegistrationUpdatedHandler = useCallback(function (taskTimeRegistrationResult) {
        var _a;
        var subTask = (_a = tasks.current) === null || _a === void 0 ? void 0 : _a.find(function (x) { return x.id === taskTimeRegistrationResult.plannedTaskId; });
        if (!subTask)
            return;
        processTimeRegistrationResult(taskTimeRegistrationResult);
    }, [processTimeRegistrationResult, tasks]);
    useEffect(function () {
        SignalRService.subscribe('taskTimeRegistrationUpdated', taskTimeRegistrationUpdatedHandler);
        return function () {
            return SignalRService.unsubscribe('taskTimeRegistrationUpdated', taskTimeRegistrationUpdatedHandler);
        };
    }, [taskTimeRegistrationUpdatedHandler]);
    var stopTimer = useCallback(function (pause) {
        if (pause === void 0) { pause = false; }
        return __awaiter(void 0, void 0, void 0, function () {
            var timeRegistrationResult, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, TimerRegistrationService.stopTimerRegistration(pause)];
                    case 1:
                        timeRegistrationResult = _a.sent();
                        return [4 /*yield*/, processTimeRegistrationResult(timeRegistrationResult)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        HandleHttpError(intl)(e_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }, [intl, processTimeRegistrationResult]);
    // Manuel click on button on subtask
    var startStopTimer = useCallback(function (t, subTask) { return __awaiter(void 0, void 0, void 0, function () {
        var runningRegistration, timerTaskId, mainTask, createStartTaskTimeRegistrationValues, timeRegistrationResult, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    subTask.disabled = true;
                    runningRegistration = TimerRegistrationService.getRunningRegistration();
                    timerTaskId = runningRegistration === null || runningRegistration === void 0 ? void 0 : runningRegistration.plannedTaskId;
                    if (!(subTask.id === timerTaskId)) return [3 /*break*/, 1];
                    // Stop timer
                    stopTimer(true);
                    subTask.disabled = false;
                    return [3 /*break*/, 7];
                case 1:
                    if (!subTask.resourceId) {
                        // Maybe open modal instead?
                        ToastrService.error(intl.formatMessage(messages.msgNoResourceDefined));
                        return [2 /*return*/];
                    }
                    if (subTask.isBlocked) {
                        // await updateTaskStatus({
                        //   id: subTask.id,
                        //   status: subTask.status,
                        //   isBlocked: !subTask.isBlocked,
                        //   inapplicable: subTask.inapplicable,
                        // });
                    }
                    mainTask = t;
                    createStartTaskTimeRegistrationValues = {
                        invoiceStreamId: subTask.invoiceStreamId,
                        resourceId: subTask.resourceId,
                        plannedTaskId: subTask.id,
                        fromMinutes: getTime(),
                        plannedTaskTemplateId: subTask.templateId,
                        plannedTaskName: subTask.name,
                        mainPlannedTaskId: mainTask.id,
                        mainTaskTemplateId: mainTask.templateId,
                        mainPlannedTaskName: mainTask.name,
                        referenceYear: subTask.year,
                    };
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 5, , 6]);
                    return [4 /*yield*/, TimerRegistrationService.createTimerRegistration(createStartTaskTimeRegistrationValues)];
                case 3:
                    timeRegistrationResult = _a.sent();
                    return [4 /*yield*/, processTimeRegistrationResult(timeRegistrationResult)];
                case 4:
                    _a.sent();
                    return [3 /*break*/, 6];
                case 5:
                    e_2 = _a.sent();
                    HandleHttpError(intl)(e_2);
                    return [3 /*break*/, 6];
                case 6:
                    subTask.disabled = false;
                    _a.label = 7;
                case 7: return [2 /*return*/];
            }
        });
    }); }, [intl, stopTimer, processTimeRegistrationResult]);
    // Status change after dragging or manual
    var startStopTimerAfterStatusChange = useCallback(function (t) { return __awaiter(void 0, void 0, void 0, function () {
        var runningRegistration, timerTaskId, subTasksWithTimer, taskType, mainTask;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (defaultCompany.taskTimeRegistrationMethod !== Method.AutomaticRegistration)
                        return [2 /*return*/];
                    runningRegistration = TimerRegistrationService.getRunningRegistration();
                    timerTaskId = runningRegistration === null || runningRegistration === void 0 ? void 0 : runningRegistration.plannedTaskId;
                    if (!!t.parentId) return [3 /*break*/, 3];
                    // Main task
                    if (t.status !== TaskStatus.Done)
                        return [2 /*return*/];
                    subTasksWithTimer = t.children.filter(function (x) {
                        if (x.type === TaskType.DefaultTime ||
                            x.type === TaskType.Mail ||
                            x.type === TaskType.AutomaticMail) {
                            return false;
                        }
                        return x.status === TaskStatus.Done && x.id === timerTaskId;
                    });
                    if (!(subTasksWithTimer.length > 0)) return [3 /*break*/, 2];
                    return [4 /*yield*/, stopTimer()];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
                case 3:
                    taskType = t.type;
                    if (taskType === TaskType.DefaultTime ||
                        taskType === TaskType.Mail ||
                        taskType === TaskType.AutomaticMail)
                        return [2 /*return*/];
                    if (!(t.status === TaskStatus.InProgress)) return [3 /*break*/, 5];
                    mainTask = tasks.current.find(function (x) { return x.id === t.parentId; });
                    return [4 /*yield*/, startStopTimer(mainTask, t)];
                case 4:
                    _a.sent();
                    return [2 /*return*/];
                case 5:
                    if (t.id !== timerTaskId)
                        return [2 /*return*/];
                    // Moved from InProgress to another status
                    return [4 /*yield*/, stopTimer()];
                case 6:
                    // Moved from InProgress to another status
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [defaultCompany.taskTimeRegistrationMethod, tasks, stopTimer, startStopTimer]);
    var onSetTasks = useCallback(function (allTasks) { return __awaiter(void 0, void 0, void 0, function () {
        var tsks;
        var _a;
        return __generator(this, function (_b) {
            tsks = (_a = allTasks === null || allTasks === void 0 ? void 0 : allTasks.reduce(function (prev, t) { var _a; return __spreadArray(__spreadArray(__spreadArray([], prev, true), ((_a = t.children) !== null && _a !== void 0 ? _a : []), true), [t], false); }, [])) !== null && _a !== void 0 ? _a : [];
            tasks.current = tsks;
            return [2 /*return*/];
        });
    }); }, []);
    var value = useMemo(function () { return ({
        processTimeRegistrationResult: processTimeRegistrationResult,
        startStopTimerAfterStatusChange: startStopTimerAfterStatusChange,
        startStopTimer: startStopTimer,
        setTasks: onSetTasks,
        isTimerRunningForSubTaskId: isTimerRunningForSubTaskId,
    }); }, [
        processTimeRegistrationResult,
        startStopTimerAfterStatusChange,
        startStopTimer,
        onSetTasks,
        isTimerRunningForSubTaskId,
    ]);
    return _jsx(TaskTimerContext.Provider, __assign({ value: value }, { children: children }));
};
export default TaskTimerProvider;
